module.exports.config = {
  "declarative": true,

  "render-module": {
    "name": "PieceShowcaseRenderModule",
    "path": "front/piece-showcase-render.module"
  },

  "cms-module": {
    "name": "PieceShowcaseCmsModule",
    "path": "front/piece-showcase-cms.module"
  },

  "definition": {
    "type": "showcase",
    "name": "PieceShowcaseDefinition",
    "group": "Media",
    "availablePlatforms": ["web"],
    "description": "Imagen con productos",

    "fields": [
      { "name": "Image", "type": "linkedImages", "mandatory": true },
      { "name": "preloadImage",  "label": "Precargar imagen en SSR", "type": "boolean", "defaultValue": false, "isExcluded": true },
      { "name": "title", "label": "Título", "placeholder": "Title (SEO)", "type": "plainText" },
      { "name": "alt", "label": "Texto alternativo", "placeholder": "Texto accesibilidad", "type": "plainText" },
      { "name": "linkedProducts", "label": "Productos", "type": "linkedProducts" },
      { "label": "Marcador", "type": "groupCollapsable", "flattenFields": true, "fields":[
        { "name": "customMarkerIcon", "label": "Personalizar marcador", "placeholder": "Icono personalizado", "type": "icon", "mandatory": false },
        { "name": "markerIconSize", "label": "Tamaño del marcador", "type": "responsiveSize", "defaultValue": "20px" }]
      },
      { "label": "Tooltip", "type": "groupCollapsable", "flattenFields": true, "fields":[
        { "name": "showTooltips", "label": "Mostrar tooltips", "type": "groupToggleable", "flattenFields": true, "defaultValue": true, "mandatory": true, "fields": [
          { "name": "alwaysVisibleTooltips", "label": "Siempre visible", "type": "boolean", "defaultValue": false, "mandatory": true, "helpText": "El tooltip estará siempre visible sin necesidad de hacer hover" },
          { "name": "showNameInTooltip", "label": "Nombre", "type": "boolean", "defaultValue": true, "mandatory": true, "isExcluded": true },
          { "name": "showPriceInTooltip", "label": "Precio", "type": "groupToggleable", "flattenFields": true, "defaultValue": true, "mandatory": true, "isExcluded": true, "fields": [
            { "name": "showOldPriceInTooltip", "label": "Precio sin rebaja", "type": "boolean", "defaultValue": true, "mandatory": true }]
          }]
        }]
      },
      { "name": "objectPosition", "label": "Posición de la imagen", "type": "options", "section": "styles", "defaultValue": "center", "values": [
          { "value": "center", "label": "Centro" },
          { "value": "top", "label": "Arriba" },
          { "value": "bottom", "label": "Abajo" }
        ]
      },
      { "name": "objectFit", "label": "Proporción de la imagen", "type": "options", "section": "styles", "defaultValue": "cover", "values": [
          { "value": "contain", "label": "Contain" },
          { "value": "cover", "label": "Cover" }
        ]
      },
      {
        "label": "Enlace",
        "type": "groupCollapsable",
        "flattenFields": true,
        "fields": [
          {
            "name": "link",
            "label": "Dirección de enlace",
            "type": "link"
          }
        ]
      }
    ]
  }
};
